import {DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {ApiPathsService} from "../../../app/api-paths.service";
import {CouponType, CouponTypeObject, stampa_id} from "./SanPellegrino";
import {getDateYear} from "../../Utility/DateUtility";
import {Permission} from "../../../app/Login/_guards/Permission";
import {CreateCustomer, MapNewCliente} from "./ClientiAgenti"
import {VerticalSidebarComponent} from "../../../app/layouts/vertical-sidebar/vertical-sidebar.component";


function campoCustom(nome: string, valore:((coupon,parent?)=>string )| string, show?:(x,permission)=>boolean): CampoAggiuntivo {
  return {
    nome: nome, oggetti: ["prezzo"], type: 'html', hideif:{func:show}, func: (coupon, parent?) => [typeof valore == "string" ? valore : valore(coupon,parent)]
  }
}

function AssegnaCliente(coupon, api: ApiPathsService, originalTask, campiModificati, component: DynamicCrudService, nosend?:boolean){
  if(!campiModificati.email || !campiModificati.nominativo ) {
    component.Toastr.error("I campi Email e nominativo sono richiesti.");
    return;
  }
  if(Object.getOwnPropertyNames(campiModificati).length>1 ){ // praticamente sempre perche abbiamo aggiunto il controllo su email
    // if(!campiModificati.piva) {
    //   component.Toastr.error("Per inserire ulteriori informazioni del cliente è necessario indicare la partita IVA.");
    //   return;
    // }
    CreateCustomerAndSend(coupon,campiModificati ,api, component,nosend);
  }

}

export function GetEmailInvioCoupon(coupon){
  return `Gentile Cliente,\n siamo lieti di inviarle il seguente coupon: ${coupon.correlatiObject[0].prodotto}. \nPotrai registrarlo al seguente link: Https://www.klimaitalia.it/sanpellegrino https://www.klimaitalia.it/sanpellegrino`
}
function SendEmail(coupon,campiModificati ,api:ApiPathsService, cliente_id?:number, nosend?:boolean ){
  const email = {
    id: coupon.id,
    cliente: cliente_id,
    subject: nosend ? undefined : `Coupon Sanpellegrino`,
    body: nosend ? undefined : GetEmailInvioCoupon(coupon),
    stampa: nosend ? undefined : stampa_id(coupon),
  }


  api.ClassicPost("/prodotti/coupon/send", {...campiModificati, ...email}).subscribe(() => {

  });
}
function CreateCustomerAndSend(coupon,campiModificati ,api:ApiPathsService, component:DynamicCrudService,nosend?:boolean){
  CreateCustomer(campiModificati, api, (cliente)=>{
    SendEmail(coupon,campiModificati ,api, cliente.id, nosend);
  })
}

function assegnazioneClienti(): OggettoConfig {
  var OBJ: OggettoConfig = {
    Id: "clienti",
    fullListRoute: "/prodotti/list",
    RestRoute: "/prodotti",
    ListDefaultFilter: {tipo: 50},
    FullExportExcel:true,
    ListResponseHasData:true,
    MenuItems: [
      {
        path: "/sanpellegrino/shared/dynamiclist/clienti",
        title: "Assegnazione Clienti",
        icon: "fa-solid fa-people-arrows",
        class: "",
        capacita: [],
        show:(component: VerticalSidebarComponent)=>component.permission.isntAccessRoles([19]),
        ruoliOperativi:["AG","NAM", "SA", "AZ"]
      },
    ],
    Filters:[
      CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "col-lg-3", ),
      CampoAggiuntivo.SingleDropdown("Stato ordine", "stato",[
        {id: "SDA", label: "Da assegnare"},
        {id: "SA", label: "Assegnati"},
        {id: "SAA", label: "Assegnati ad Agente"},
        {id: "SPV", label: "Assegnati al PV"},
        {id: "SBS", label: "Bonifico Segnalato"},
        {id: "SPA", label: "Pagato"},
        {id: "SSP", label: "Spedito"},
      ],"label", {}, 'col-lg-3'),
      CampoAggiuntivo.InputField("Cliente (PV)", "cliente", "text", "col-lg-3", ),
      CampoAggiuntivo.SingleDropdown(
        "Manager",
        "stato",
        "/anagrafica/profilo/cliente",
        "fullName",
        {
          parameter: [],
          responseHasData: false,
          responseMap(profilo){
            return profilo.referenti?.filter(x=>x.ruoliAccessoObject.find(y=>y.id == 24 || y.id == 25))
          }
        },
        'col-lg-3',
        (x,y:Permission)=> y.isOperativeRoles(['S'])
      ),

    ],

    Headers: [
      campoCustom("Lotto",(coupon) =>getDateYear(coupon.dataScadenza1)?.toString()),
      CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "", {modificabile: false}),
      campoCustom("Stato", (coupon) =>  {
        if(coupon.statoCoupon)//spedito)
          return coupon.statoCoupon;
        if(false)//pagato)
          return "Pagato";
        if(false)//bonifico segnalato)
          return "Bonifico Segnalato";
        if(coupon.cliente || coupon.video)
          return "Assegnato a PV";
        if(coupon.agenteCoupon)
          return "Assegnato ad Agente";
        if(coupon.dmCoupon)
          return "Assegnato a DM";
        if( coupon.namCoupon)
          return "Assegnato al NAM"
        return "DA ASSEGNARE";
      }),
      campoCustom("Prodotto", (coupon)=>coupon.correlatiObject?.reduce((a,c)=>`${a} ${c.prodotto?.replaceAll("COUPON ", "")?.replaceAll("SELL IN ", "")?. replaceAll("SELL OUT ", "")?. replaceAll("OMAGGIO ", "")}`,'')),
      campoCustom("Tipo Coupon", (coupon) =>CouponTypeObject(coupon).label),
      campoCustom("Cliente (PV)", (coupon) => coupon.clienteObject?.nominativo ?? coupon.video ?? ""),
      campoCustom("Email", (movimentazione) => movimentazione.video ),
      campoCustom("Agente", (coupon) => coupon.agenteCoupon?.fullName ?? "", (x,permission:Permission)=>permission.isntOperativeRole('NAM')),
      campoCustom("Manager", (coupon) => coupon.dmCoupon?.fullName ?? coupon.namCoupon?.fullName ?? ""),
      campoCustom("Danneggiato", (coupon)=>coupon.danneggiato ),
      campoCustom("Sostituito", (coupon)=>coupon.sostituito ),
      campoCustom("Data Assegnazione", (coupon) => coupon?.dataAssegnazione)


    ],
    DisableEdit: false,
    AzioniLista: [
      {
        nome: 'Assegna',
        close: false,
        icon: 'ui ui-user-send text-info',
        class: ' btn p-0',
        labelClass: 'text-info ',
        type: 'edit',
        tooltip: "Assegna un Cliente e invia la mail",
        noEditFill: true,
        customSave: AssegnaCliente,
        campi: [
          CampoAggiuntivo.InputField("e-mail", "email", "email", "col-lg-3", {modificabile: true}),
          CampoAggiuntivo.InputField("Nominativo", "nominativo", "text", "col-lg-3", {}),
          CampoAggiuntivo.InputField("Partita iva", "piva", "text", "col-lg-3", {}),
          campoCustom("", (coupon) => "Verrà allegata all'email il coupon e la scheda prodotto in formato PDF")
        ]
      },
      {
        nome: 'Assegna senza Inviare Email',
        close: false,
        icon: 'ui ui-user-send-off text-info',
        class: ' btn p-0',
        labelClass: 'text-info ',
        type: 'edit',
        tooltip: "Assegna un Cliente senza inviare la mail",
        noEditFill: true,
        customSave: (coupon,api,originalTask,campiModificati,component)=>AssegnaCliente(coupon,api,originalTask,campiModificati,component, true),
        campi: [
          CampoAggiuntivo.InputField("e-mail", "email", "email", "col-lg-3", {modificabile: true}),
          CampoAggiuntivo.InputField("Nominativo", "nominativo", "text", "col-lg-3", {}),
          CampoAggiuntivo.InputField("Partita iva", "piva", "text", "col-lg-3", {}),
        ]
      },
      {
        nome: 'Scarica coupon',
        close: false,
        icon: 'fa-solid fa-download text-info',
        class: ' btn p-0',
        labelClass: 'text-info ',
        type: 'func',
        hideif:{func:(x)=>x.video && x.cliente},
        tooltip: "Scarica il file del coupon",
        func:(x, api:ApiPathsService)=>{
          api.ClassicPost("/prodotti/get", x).subscribe(coupon=>{
            api.FilePost("/prodotti/coupon/print", {id: x.id, stampa: stampa_id(coupon)}).subscribe((data)=>{
              api.downloadService.downloadFile(data)
            })
          })

        }
      },
      {
        nome: 'Stampa coupon',
        close: false,
        icon: 'fa-solid fa-print text-info',
        class: ' btn p-0',
        labelClass: 'text-info ',
        type: 'func',
        hideif:{func:(x)=>x.video && x.cliente},
        tooltip: "Stampa il PDF del coupon",
        func:(x, api:ApiPathsService)=>{
          api.ClassicPost("/prodotti/get", x).subscribe(coupon=>{
            api.FilePost("/prodotti/coupon/print", {id: x.id, stampa: stampa_id(coupon)}).subscribe((data)=>{
              api.downloadService.printFile(data)
            })
          })

        }
      },
      {
        nome: 'Invia Email',
        close: false,
        icon: 'fa-regular fa-paper-plane text-info',
        class: ' btn p-0',
        labelClass: 'text-info ',
        type: 'func',
        hideif:{func:(x)=>x.video && x.cliente},
        tooltip: "Invia email con il coupon e la scheda prodotto in formato PDF",
        func:( x, api:ApiPathsService)=>{
          api.ClassicPost("/prodotti/get", x).subscribe(coupon=>{
            const email = {
              id: coupon.id,
              cliente: coupon.cliente,
              subject:  `Coupon Sanpellegrino` ,
              body: GetEmailInvioCoupon(coupon),
              stampa: stampa_id(coupon) ,
              email: coupon.video,
              nominativo: coupon.clienteObject.nominativo,
            }
            api.ClassicPost("/prodotti/coupon/send", {...email}).subscribe(data=>{
            })
          })

          //api.DownloadFileByID()
        }
      },
    ]
  }


  return OBJ;
}


export var assegnazioneClientiEnv = () => {
  var env: any = {
    Modules: {
      "assegnazioneClienti": true
    },
    Cruds: [assegnazioneClienti()],
    Menu: [...assegnazioneClienti().MenuItems]
  }
  return env;

}
